export enum MemberRegistrationUserType {
  Officers = 1,
  Staff = 2,
}
